import { observer } from '@formily/react'
import { Table } from 'antd'
import { createStyles } from 'antd-style'

import { EditableTableRow } from './components/TableRow'
import { CommonTableRowProps } from './components/TableRow/interface'
import { useEditableTableColumns } from './hooks/useColumns'
import { useEditableTableDataSource } from './hooks/useDataSource'
import { useEditableTableSchema } from './hooks/useSchema'
import { EditableTableProps } from './interface'

const useStyles = createStyles(({ prefixCls }) => ({
  table: {
    width: '100%',
    [`&.${prefixCls}-table-wrapper .${prefixCls}-table-thead >tr>th`]: {
      fontWeight: 'normal'
    }
  }
}))

const defaultVirtualProps = {
  virtual: true,
  scroll: { y: 500 },
  components: {
    body: {
      row: EditableTableRow.Virtual
    }
  }
}
// EditableTableRow 组件的属性
const onRow = (record: any, index: number = 0): CommonTableRowProps => {
  return {
    record,
    index
  }
}

export const EditableTable = observer(
  ({
    className,
    bordered = false,
    size = 'small',
    ...restProps
  }: EditableTableProps) => {
    const schema = useEditableTableSchema()

    const columns = useEditableTableColumns(schema)

    const { rowKey, dataSource } = useEditableTableDataSource()

    const virtualProps = dataSource.length >= 100 ? defaultVirtualProps : {}

    const { cx, styles } = useStyles()
    return (
      <Table
        {...restProps}
        bordered={bordered}
        className={cx(styles.table, className)}
        columns={columns}
        components={{ body: { row: EditableTableRow } }}
        dataSource={dataSource}
        pagination={false}
        rowKey={rowKey}
        size={size}
        onRow={onRow}
        {...virtualProps}
      />
    )
  }
)
